export class HAxis {
    maxValue?: number;
    title?: string;
}
